import { BaseSlideProps, SlideItemType } from '../../types';
import { AnamneseCard } from '../AnamneseCard';

export const AnamneseSlide = ({ slide }: BaseSlideProps) => {
  const anamneseItem = slide.items.find((item) => item.type === SlideItemType.ANAMNESE);

  if (!anamneseItem || anamneseItem.type !== SlideItemType.ANAMNESE) return null;

  return (
    <AnamneseCard
      variant="slide"
      gender={anamneseItem.gender}
      title={anamneseItem.title}
      descriptionList={anamneseItem.descriptionList}
    />
  );
};
